/* ============================================================
   ns-saury-lp.js: 鮮さんま特設ページ(/pages/saury)
   - 選択の状態は1つ {tab, vid, qty}。購入ボックス・購入シート・ドックの
     どこで変えても、render()が全部を描き直す。
   - 規格の表示名・目安・価格は購入ボックスのHTMLから読み取る(元は1か所)。
   - お届けの時間帯はカートの注文備考(cart.note)の1行として書き込む。
     「ご注文へ進む」は、カートがこのページの商品だけならチェックアウトへ直接、
     ほかの商品も入っていればカートページへ(年齢確認などカート側の手続きを通すため)。
   - 受付終了: 締切日時(data-deadline)と、読み込み時の販売状態の取り直し。
   - 購入シートを開いている間は、キーボードの移動をシートの中に閉じ込め、背面のページを操作できなくする。
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-nssm-root]');
  if (!root) return;
  var html = document.documentElement;
  html.classList.add('nssm-js');

  var MAX_QTY = 10;
  var ADD_WAIT = 12000; /* カートに入れる通信の待ち時間の上限 */
  var MSG_FAIL = 'カートに追加できませんでした。時間をおいてお試しください。';
  var MSG_STOCK = 'ご用意できる数を超えています。箱数を減らしてお試しください。';
  var MSG_SOLD = 'ただいまご用意できる数を超えています。受付の状況を取り直しました。';
  var MSG_NET = '通信に失敗しました。カートには入っていません。電波の良い場所でもう一度お試しください。';
  var MSG_SLOW = '通信に時間がかかっています。カートには入っていません。電波の良い場所でもう一度お試しください。';
  var MSG_PART = '一部だけカートに入りました。中身をお確かめください。';
  var MSG_CHECK = 'カートに入ったかどうかを確認できませんでした。二重にならないよう、中身をお確かめください。';
  var MSG_NOTE = '時間帯を保存できませんでした。カートページでご指定ください。';
  var SLOT_KEY = 'お届け時間帯のご希望：';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function yen(cents) { return '¥' + Math.round(cents / 100).toLocaleString('ja-JP'); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function normQty(v) {
    var n = parseInt(v, 10);
    if (isNaN(n) || n < 1) n = 1;
    if (n > MAX_QTY) n = MAX_QTY;
    return n;
  }
  var ICON_X = '<svg viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M1.5 1.5l11 11M12.5 1.5l-11 11" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round"/></svg>';
  var ICON_PLUS = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><rect x="7" y="1" width="2" height="14"/><rect x="1" y="7" width="14" height="2"/></svg>';
  var QTY_MINUS = '<svg class="nssm-qico" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><rect x="2" y="7" width="12" height="2"/></svg>';
  var QTY_PLUS = '<svg class="nssm-qico" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><rect x="7" y="2" width="2" height="12"/><rect x="2" y="7" width="12" height="2"/></svg>';
  var ICON_CHEV = '<svg class="nssm-slot__chev" viewBox="0 0 12 8" aria-hidden="true" focusable="false"><path d="M1 1.5 6 6.5 11 1.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ---------- リビール ---------- */
  (function reveal() {
    var items = $$('.nssm-reveal', root);
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });
  })();

  /* ---------- FV: ヘッダー実測高・ロード演出 ---------- */
  (function fv() {
    var el = $('#fv', root);
    if (!el) return;
    function setHeaderVar() {
      var h = document.querySelector('.shopify-section__header');
      if (h) el.style.setProperty('--nssm-header-h', Math.round(h.getBoundingClientRect().height) + 'px');
    }
    setHeaderVar();
    window.addEventListener('resize', setHeaderVar, { passive: true });
    /* サイトのヘッダーは、読み込みの途中で高さが変わる(このページだけ検索欄を出さない指定・書体の読み込み)。
       はじめの1回だけで決めると古い高さが残り、FVの写真がその分だけ低くなる。
       ページの先頭にいる時だけ測り直す(読み進めた後に組み直して画面が動くのを防ぐため)。 */
    function remeasure() {
      if ((window.pageYOffset || document.documentElement.scrollTop || 0) < 40) setHeaderVar();
    }
    window.addEventListener('load', remeasure);
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(remeasure)['catch'](function () { /* 書体を待てない環境は下の保険で測る */ });
    }
    var hdrEl = document.querySelector('.shopify-section__header');
    if (hdrEl && window.ResizeObserver) {
      try { new window.ResizeObserver(remeasure).observe(hdrEl); } catch (e) { /* 監視できない環境も下の保険で足りる */ }
    }
    window.setTimeout(remeasure, 1500);
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { el.classList.add('is-live'); });
    });
  })();

  /* ---------- 購入ボックスから規格を読み取る ---------- */
  var form = $('[data-nssm-form]', root);
  var tabInputs = $$('input[name="nssm-tab"]', root);
  var vInputs = $$('input[name="id"]', root);
  var qtyInput = $('[data-nssm-qty-input]', root);
  var totalEl = $('[data-nssm-total]', root);
  var addBtn = $('[data-nssm-add]', root);
  var fbEl = $('[data-nssm-feedback]', root);
  var nextEl = $('[data-nssm-next]', root);
  var cartLineEl = $('[data-nssm-cartline]', root);
  var slotSel = $('[data-nssm-slot]', root);
  var checkoutEl = $('[data-nssm-checkout]', root);
  /* 時間帯の選択肢も購入ボックスのHTMLが元(シートはここから作る) */
  var SLOTS = slotSel ? $$('option', slotSel).map(function (o) { return { v: o.value, t: o.textContent }; }) : [];
  function slotOk(v) { return SLOTS.some(function (s) { return s.v === v; }); }

  var TABS = {};
  var TAB_KEYS = [];
  tabInputs.forEach(function (inp) {
    var lab = inp.closest('.nssm-tab');
    var pane = $('[data-nssm-pane="' + inp.value + '"]', root);
    var descEl = pane ? $('[data-nssm-desc]', pane) : null;
    TABS[inp.value] = {
      key: inp.value,
      name: lab ? $('.nssm-tab__n', lab).textContent : '',
      sub: lab ? $('.nssm-tab__s', lab).textContent : '',
      handle: inp.getAttribute('data-handle'),
      input: inp,
      label: lab,
      pane: pane,
      desc: descEl ? descEl.textContent : ''
    };
    TAB_KEYS.push(inp.value);
  });
  var VARS = vInputs.map(function (inp) {
    return {
      id: String(inp.value),
      tab: inp.getAttribute('data-tab'),
      price: parseInt(inp.getAttribute('data-price'), 10) || 0,
      n: inp.getAttribute('data-n') || '',
      short: inp.getAttribute('data-short') || '',
      hint: inp.getAttribute('data-hint') || '',
      ok: !inp.disabled,
      input: inp,
      label: inp.closest('.nssm-opt')
    };
  });
  function varsOf(k) { return VARS.filter(function (v) { return v.tab === k; }); }
  function tabOk(k) { return varsOf(k).some(function (v) { return v.ok; }); }
  function findVar(id) { return VARS.filter(function (v) { return v.id === String(id); })[0] || null; }
  /* タブを変えた時は真ん中(10尾・約1kg)を初期にする。完売なら次へ */
  function pickDefault(k) {
    var list = varsOf(k);
    var order = [1, 0, 2];
    for (var i = 0; i < order.length; i++) {
      var v = list[order[i]];
      if (v && v.ok) return v;
    }
    for (var j = 0; j < list.length; j++) { if (list[j].ok) return list[j]; }
    return null;
  }

  var closed = root.classList.contains('is-closed') || !VARS.length;
  var state = { tab: null, vid: null, qty: 1, slot: '' };
  (function initState() {
    var checked = vInputs.filter(function (i) { return i.checked; })[0];
    if (checked && !checked.disabled) {
      state.vid = String(checked.value);
      state.tab = checked.getAttribute('data-tab');
      return;
    }
    var k = TAB_KEYS.filter(tabOk)[0];
    if (k) {
      var d = pickDefault(k);
      state.tab = k;
      state.vid = d ? d.id : null;
    }
  })();

  /* ---------- 通知(どこで入れたかで出す場所を変える) ---------- */
  var fb = { from: null, msg: '', error: false };
  var adding = false;
  var addingFrom = null;
  var cartCount = 0;
  var cartTotal = 0;
  var cartNote = '';
  var cartLines = null; /* 規格ごとの箱数。null は「カートをまだ読めていない」 */
  var slotTouched = false;
  var leaving = false;

  function resetFeedback() { fb = { from: null, msg: '', error: false, cart: false }; }
  /* 案内の文。中身を確かめていただく時は、カートへの導線も添える */
  function fbHtml() {
    return esc(fb.msg) + (fb.cart ? '<a class="nssm-fb__cart" href="/cart">カートの中身を見る</a>' : '');
  }

  /* ---------- 描き直し ---------- */
  function render() {
    var cur = findVar(state.vid);
    TAB_KEYS.forEach(function (k) {
      var t = TABS[k];
      var on = k === state.tab;
      var ok = tabOk(k);
      t.input.checked = on;
      t.input.disabled = !ok;
      if (t.label) {
        t.label.classList.toggle('is-on', on);
        t.label.classList.toggle('is-off', !ok);
        var s = $('.nssm-tab__s', t.label);
        if (s) s.textContent = ok ? t.sub : '受付終了';
      }
      if (t.pane) t.pane.classList.toggle('is-active', on);
    });
    VARS.forEach(function (v) {
      var on = v.id === state.vid;
      v.input.checked = on;
      v.input.disabled = !v.ok;
      if (v.label) {
        v.label.classList.toggle('is-on', on);
        v.label.classList.toggle('is-off', !v.ok);
        v.label.classList.toggle('is-hidden', v.tab !== state.tab);
        var p = $('.nssm-opt__p', v.label);
        if (p) p.textContent = v.ok ? yen(v.price) : '完売';
      }
    });
    if (qtyInput) qtyInput.value = state.qty;
    if (totalEl) totalEl.textContent = cur ? yen(cur.price * state.qty) : '';
    /* 「ご注文へ進む」: ここで入れた直後か、カートに1点以上ある時。
       その間は「ご注文へ進む」を主ボタン(朱)にし、「カートに入れる」は枠だけのボタンに下げる */
    var boxOk = fb.from === 'box' && !fb.error;
    var ordering = boxOk || cartCount > 0;
    if (addBtn) {
      addBtn.disabled = adding || !cur;
      addBtn.textContent = adding && addingFrom === 'box' ? 'カートに追加しています' : 'カートに入れる';
      addBtn.classList.toggle('nssm-btn--primary', !ordering);
      addBtn.classList.toggle('nssm-btn--outline', ordering);
    }
    if (fbEl) {
      var boxFb = fb.from === 'box';
      fbEl.innerHTML = boxFb ? fbHtml() : '';
      fbEl.classList.toggle('is-shown', boxFb);
      fbEl.classList.toggle('is-error', boxFb && fb.error);
    }
    if (nextEl) nextEl.classList.toggle('is-shown', ordering);
    if (cartLineEl) {
      cartLineEl.hidden = cartCount < 1;
      cartLineEl.textContent = cartSummary();
    }
    if (slotSel) slotSel.value = state.slot;
    renderSheet();
    renderDock();
  }

  function setTab(k) {
    if (closed || !TABS[k] || !tabOk(k)) return;
    if (state.tab !== k) {
      state.tab = k;
      var d = pickDefault(k);
      state.vid = d ? d.id : null;
      resetFeedback();
    }
    render();
  }
  function setVar(id) {
    var v = findVar(id);
    if (closed || !v || !v.ok) return;
    if (state.vid !== v.id) resetFeedback();
    state.vid = v.id;
    state.tab = v.tab;
    render();
  }
  function setQty(n) {
    var q = normQty(n);
    /* 箱数を変えたら「入れました」の表示を消す(カートの中身が変わったと誤解させない) */
    if (q !== state.qty) resetFeedback();
    state.qty = q;
    render();
  }
  function cartSummary() {
    return cartCount > 0 ? 'カートに' + cartCount + '点・合計' + yen(cartTotal) : '';
  }
  function addedMsg(v, qty) {
    return v ? v.short + (qty > 1 ? '×' + qty + '箱' : '') + 'をカートに入れました。' : 'カートに追加しました。';
  }
  function setSlot(v) {
    state.slot = slotOk(v) ? v : '';
    slotTouched = true;
    render();
    saveNote().catch(function () {
      /* 進む時にもう一度書き込むが、伝わらないままにはしない */
      fb = { from: (ov && !ov.hidden) ? 'sheet' : 'box', msg: MSG_NOTE, error: true, cart: true };
      render();
    });
  }

  /* ---------- 購入ボックスの操作 ---------- */
  tabInputs.forEach(function (inp) {
    inp.addEventListener('change', function () { setTab(inp.value); });
  });
  vInputs.forEach(function (inp) {
    inp.addEventListener('change', function () { setVar(inp.value); });
  });
  $$('[data-nssm-qty]', root).forEach(function (b) {
    b.addEventListener('click', function () {
      setQty(state.qty + (parseInt(b.getAttribute('data-nssm-qty'), 10) || 0));
    });
  });
  if (qtyInput) qtyInput.addEventListener('change', function () { setQty(qtyInput.value); });
  if (slotSel) slotSel.addEventListener('change', function () { setSlot(slotSel.value); });
  if (checkoutEl) checkoutEl.addEventListener('click', function (e) { goCheckout(e, checkoutEl); });
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart('box');
    });
  }

  /* ---------- カートに入れる ----------
     通信が途中で切れると、サーバーには入っているのに画面だけが失敗に見えることがある。
     そのまま「もう一度」と促すと二重に入るので、結果が分からない時はカートを読み直し、
     入ったかどうかを確かめてから案内する。 */
  function addToCart(from) {
    if (adding || closed) return;
    var cur = findVar(state.vid);
    if (!cur || !cur.ok) return;
    var qty = state.qty;
    var before = cartLines ? (cartLines[String(cur.id)] || 0) : null;
    adding = true;
    addingFrom = from;
    resetFeedback();
    render();

    /* 返事が来ないまま押せなくなるのを防ぐ(待つのをやめた後も、入ったかどうかは確かめる) */
    var ctrl = window.AbortController ? new window.AbortController() : null;
    var late = false;
    var timer = null;
    var giveUp = new Promise(function (resolve) {
      timer = window.setTimeout(function () {
        late = true;
        if (ctrl) { try { ctrl.abort(); } catch (e) { /* 中断できない時はそのまま先へ進む */ } }
        resolve({ lost: true });
      }, ADD_WAIT);
    });
    var opt = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(cur.id, 10), quantity: qty })
    };
    if (ctrl) opt.signal = ctrl.signal;

    Promise.race([
      fetch('/cart/add.js', opt).then(
        function (res) { return res.ok ? { ok: true } : { status: res.status }; },
        function () { return { lost: true }; }
      ),
      giveUp
    ])
      .then(function (out) {
        window.clearTimeout(timer);
        if (out.ok) {
          fb = { from: from, msg: addedMsg(cur, qty), error: false, cart: false };
          return refreshCart();
        }
        if (out.lost) return afterLost(from, cur, qty, before, late);
        if (out.status === 422) {
          /* ご用意できる数を超えた。1箱はそれ以上減らせないので、受付の状況を取り直す */
          if (qty > 1) { fb = { from: from, msg: MSG_STOCK, error: true, cart: false }; return null; }
          fb = { from: from, msg: MSG_SOLD, error: true, cart: true };
          return recheckAvailability();
        }
        fb = { from: from, msg: MSG_FAIL, error: true, cart: false };
        return null;
      })
      .catch(function () {
        fb = { from: from, msg: MSG_CHECK, error: true, cart: true };
      })
      .then(function () {
        window.clearTimeout(timer);
        adding = false;
        addingFrom = null;
        if (fb.from === 'dock' && fb.error) {
          fb.from = 'sheet';
          openSheet('', null);
        }
        render();
      });
  }

  /* 送れたかどうかが分からない時。カートを読み直し、入っていれば成功として扱う */
  function afterLost(from, cur, qty, before, late) {
    return refreshCart().then(function (c) {
      if (!c || before === null) {
        fb = { from: from, msg: MSG_CHECK, error: true, cart: true };
        return;
      }
      var now = (cartLines && cartLines[String(cur.id)]) || 0;
      if (now >= before + qty) { fb = { from: from, msg: addedMsg(cur, qty), error: false, cart: false }; return; }
      if (now > before) { fb = { from: from, msg: MSG_PART, error: true, cart: true }; return; }
      fb = { from: from, msg: late ? MSG_SLOW : MSG_NET, error: true, cart: false };
    });
  }

  function applyCart(c) {
    cartCount = c.item_count || 0;
    cartTotal = c.total_price || 0;
    cartNote = c.note || '';
    cartLines = {};
    (c.items || []).forEach(function (it) {
      var k = String(it.variant_id);
      cartLines[k] = (cartLines[k] || 0) + (it.quantity || 0);
    });
    if (!slotTouched) state.slot = parseSlot(cartNote);
    render();
    html.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    return c;
  }
  function readCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
      .then(applyCart);
  }
  /* 読めた時はカートの中身を、読めなかった時は null を返す(表示はそのまま保つ) */
  function refreshCart() {
    return readCart().catch(function () { return null; });
  }

  /* ---------- お届けの時間帯(カートの注文備考の1行) ---------- */
  function splitNote(note) { return String(note || '').split(/\r?\n/); }
  function parseSlot(note) {
    var lines = splitNote(note);
    for (var i = 0; i < lines.length; i++) {
      if (lines[i].indexOf(SLOT_KEY) === 0) {
        var v = lines[i].slice(SLOT_KEY.length).replace(/^\s+|\s+$/g, '');
        return slotOk(v) ? v : '';
      }
    }
    return '';
  }
  /* お客さまがカートで書いた備考は残し、時間帯の行だけを差し替える */
  function composeNote(note, slot) {
    var rest = splitNote(note).filter(function (l) { return l.indexOf(SLOT_KEY) !== 0; })
      .join('\n').replace(/^\s+|\s+$/g, '');
    if (!slot) return rest;
    return SLOT_KEY + slot + (rest ? '\n' + rest : '');
  }
  /* 書き込みは1本ずつ順番に行う(並ぶと、古い選択が後から届いて上書きすることがあるため)。
     書き込む直前にカートを読み直し、その時の備考へ時間帯の行だけを差し替える
     (お客さまがカートページや別のタブで書いた備考を消さないため)。 */
  var noteChain = Promise.resolve();
  function queueNote(fn) {
    var p = noteChain.then(fn, fn);
    noteChain = p.then(function () { }, function () { });
    return p;
  }
  function writeNote() {
    return readCart().then(function (c) {
      var body = composeNote(c.note || '', state.slot);
      if (body === String(c.note || '')) return c; /* 変わらないなら書き込まない */
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note: body })
      })
        .then(function (r) { if (!r.ok) throw new Error('note ' + r.status); return r.json(); })
        .then(applyCart);
    });
  }
  function saveNote() { return queueNote(writeNote); }
  /* 時間帯に触れていない時は備考を書き換えず、カートの中身だけを読む */
  function commitNote() { return queueNote(slotTouched ? writeNote : readCart); }

  /* ---------- ご注文へ進む ---------- */
  function onlyThisPage(c) {
    var items = (c && c.items) || [];
    if (!items.length) return false;
    return items.every(function (it) { return !!findVar(it.variant_id); });
  }
  function setBusy(el, on) {
    if (!el) return;
    el.classList.toggle('is-busy', on);
    if (on) el.setAttribute('aria-busy', 'true'); else el.removeAttribute('aria-busy');
  }
  var busyEl = null;
  function goCheckout(e, el) {
    if (e) e.preventDefault();
    if (leaving) return;
    leaving = true;
    busyEl = el || null;
    setBusy(busyEl, true);
    var done = false;
    function go(url) {
      if (done) return;
      done = true;
      window.location.href = url;
    }
    /* 書き込みが返らない時は、備考欄のあるカートページへ */
    var timer = window.setTimeout(function () { go('/cart'); }, 6000);
    commitNote().then(function (c) {
      window.clearTimeout(timer);
      go(onlyThisPage(c) ? '/checkout' : '/cart');
    }, function () {
      window.clearTimeout(timer);
      go('/cart');
    });
  }
  /* チェックアウトから戻るボタンで戻った時(ページの復元)に、ボタンとカートの表示を戻す */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    leaving = false;
    setBusy(busyEl, false);
    busyEl = null;
    refreshCart();
  });

  /* ---------- 購入シート(SPは下から・PCは中央) ---------- */
  var ov = null, sheet = null, S = {}, lastFocus = null;
  var sheetActive = false; /* 開いている(閉じる動きの途中は含まない) */
  var closeTimer = null;

  function buildSheet() {
    ov = document.createElement('div');
    ov.className = 'nssm-sheet-ov';
    ov.hidden = true;
    sheet = document.createElement('div');
    sheet.className = 'nssm-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-labelledby', 'nssm-sheet-title');
    sheet.tabIndex = -1;

    var tabs = TAB_KEYS.map(function (k) {
      var t = TABS[k];
      return '<label class="nssm-tab"><input type="radio" name="nssm-sheet-tab" value="' + esc(k) + '">' +
        '<span class="nssm-tab__n">' + esc(t.name) + '</span><span class="nssm-tab__s">' + esc(t.sub) + '</span></label>';
    }).join('');
    var descs = TAB_KEYS.map(function (k) {
      return '<p class="nssm-pane__desc" data-sheet-desc="' + esc(k) + '">' + esc(TABS[k].desc) + '</p>';
    }).join('');
    var opts = VARS.map(function (v) {
      return '<label class="nssm-opt" data-sheet-opt="' + esc(v.id) + '"><input type="radio" name="nssm-sheet-v" value="' + esc(v.id) + '">' +
        '<span class="nssm-opt__main"><span class="nssm-opt__n">' + esc(v.n) + '</span><span class="nssm-opt__h">' + esc(v.hint) + '</span></span>' +
        '<span class="nssm-opt__p"></span></label>';
    }).join('');
    var thumb = root.getAttribute('data-nssm-thumb') || '';
    var slotRow = SLOTS.length ?
      '<div class="nssm-slot"><label class="nssm-slot__label" for="nssm-sheet-slot">お届けの時間帯</label>' +
        '<span class="nssm-slot__field"><select id="nssm-sheet-slot" data-sheet-slot>' +
        SLOTS.map(function (s) { return '<option value="' + esc(s.v) + '">' + esc(s.t) + '</option>'; }).join('') +
        '</select>' + ICON_CHEV + '</span></div>' : '';

    sheet.innerHTML =
      '<button type="button" class="nssm-sheet__x" data-sheet-close aria-label="閉じる">' + ICON_X + '</button>' +
      '<div class="nssm-sheet__head">' +
        (thumb ? '<img class="nssm-sheet__thumb" src="' + esc(thumb) + '" alt="" width="52" height="52">' : '') +
        '<div><p class="nssm-sheet__title" id="nssm-sheet-title">大きさと量を選ぶ</p><p class="nssm-sheet__sub">鎌田水産の鮮さんま</p></div>' +
      '</div>' +
      '<div class="nssm-sheet__scroll" data-sheet-scroll>' +
        '<p class="nssm-step nssm-step--tabs">大きさを選ぶ</p>' +
        '<div class="nssm-tabs" role="radiogroup" aria-label="大きさを選ぶ">' + tabs + '</div>' + descs +
        '<p class="nssm-step">量を選ぶ</p>' +
        '<div class="nssm-opts" role="radiogroup" aria-label="量を選ぶ">' + opts + '</div>' +
        '<details class="nssm-sheet__info"><summary>お届けと注意事項' + ICON_PLUS + '</summary><div data-sheet-info></div></details>' +
      '</div>' +
      '<div class="nssm-sheet__foot">' +
        '<div class="nssm-sheet__row1"><p class="nssm-sheet__label" data-sheet-label role="status" aria-live="polite"></p>' +
          '<button type="button" class="nssm-sheet__close" data-sheet-close>閉じる</button></div>' +
        '<div class="nssm-sheet__buy">' +
          '<div class="nssm-sheet__sum"><b data-sheet-total></b><small>送料込み</small></div>' +
          '<span class="nssm-stepper"><button type="button" data-sheet-qty="-1" aria-label="箱数を1減らす">' + QTY_MINUS + '</button>' +
          '<b data-sheet-count aria-live="polite">1</b>' +
          '<button type="button" data-sheet-qty="1" aria-label="箱数を1増やす">' + QTY_PLUS + '</button></span>' +
          '<button type="button" class="nssm-btn nssm-btn--primary nssm-sheet__add" data-sheet-add>カートに入れる</button>' +
        '</div>' +
        '<div class="nssm-sheet__order" data-sheet-order hidden>' +
          '<p class="nssm-sheet__cartsum" data-sheet-cartsum></p>' + slotRow +
          (slotRow ? '<p class="nssm-slot__note">選んだ時間帯は、ご注文の備考としてお店に届きます。</p>' : '') +
          '<a href="/cart" class="nssm-btn nssm-btn--wide nssm-btn--primary nssm-sheet__proceed" data-sheet-proceed>ご注文へ進む</a>' +
        '</div>' +
      '</div>';

    var info = $('template[data-nssm-sheet-info]', root);
    var infoBox = $('[data-sheet-info]', sheet);
    if (info && infoBox && info.content) infoBox.appendChild(info.content.cloneNode(true));

    ov.appendChild(sheet);
    document.body.appendChild(ov);

    S = {
      scroll: $('[data-sheet-scroll]', sheet),
      label: $('[data-sheet-label]', sheet),
      total: $('[data-sheet-total]', sheet),
      count: $('[data-sheet-count]', sheet),
      add: $('[data-sheet-add]', sheet),
      proceed: $('[data-sheet-proceed]', sheet),
      order: $('[data-sheet-order]', sheet),
      cartsum: $('[data-sheet-cartsum]', sheet),
      slot: $('[data-sheet-slot]', sheet),
      info: $('.nssm-sheet__info', sheet)
    };

    ov.addEventListener('click', function (e) { if (e.target === ov) closeSheet(); });
    $$('[data-sheet-close]', sheet).forEach(function (b) { b.addEventListener('click', closeSheet); });
    sheet.addEventListener('change', function (e) {
      var t = e.target;
      if (t.name === 'nssm-sheet-tab') setTab(t.value);
      else if (t.name === 'nssm-sheet-v') setVar(t.value);
    });
    $$('[data-sheet-qty]', sheet).forEach(function (b) {
      b.addEventListener('click', function () {
        setQty(state.qty + (parseInt(b.getAttribute('data-sheet-qty'), 10) || 0));
      });
    });
    S.add.addEventListener('click', function () { addToCart('sheet'); });
    S.proceed.addEventListener('click', function (e) { goCheckout(e, S.proceed); });
    if (S.slot) S.slot.addEventListener('change', function () { setSlot(S.slot.value); });
  }

  function renderSheet() {
    if (!sheet) return;
    var cur = findVar(state.vid);
    $$('input[name="nssm-sheet-tab"]', sheet).forEach(function (inp) {
      var k = inp.value;
      var on = k === state.tab;
      var ok = tabOk(k);
      var lab = inp.closest('.nssm-tab');
      inp.checked = on;
      inp.disabled = !ok;
      lab.classList.toggle('is-on', on);
      lab.classList.toggle('is-off', !ok);
      $('.nssm-tab__s', lab).textContent = ok ? TABS[k].sub : '受付終了';
    });
    $$('[data-sheet-desc]', sheet).forEach(function (p) {
      p.hidden = p.getAttribute('data-sheet-desc') !== state.tab;
    });
    $$('[data-sheet-opt]', sheet).forEach(function (lab) {
      var v = findVar(lab.getAttribute('data-sheet-opt'));
      if (!v) return;
      var inp = $('input', lab);
      var on = v.id === state.vid;
      inp.checked = on;
      inp.disabled = !v.ok;
      lab.classList.toggle('is-on', on);
      lab.classList.toggle('is-off', !v.ok);
      lab.classList.toggle('is-hidden', v.tab !== state.tab);
      $('.nssm-opt__p', lab).textContent = v.ok ? yen(v.price) : '完売';
    });
    S.count.textContent = state.qty;
    S.total.textContent = cur ? yen(cur.price * state.qty) : '';
    if (fb.from === 'sheet') {
      S.label.innerHTML = fbHtml();
      S.label.className = 'nssm-sheet__label ' + (fb.error ? 'is-error' : 'is-ok');
    } else {
      S.label.textContent = cur ? cur.short + (state.qty > 1 ? '×' + state.qty + '箱' : '') : '';
      S.label.className = 'nssm-sheet__label';
    }
    var ordering = cartCount > 0 || (fb.from === 'sheet' && !fb.error);
    S.order.hidden = !ordering;
    S.cartsum.textContent = cartSummary();
    S.cartsum.hidden = cartCount < 1;
    if (S.slot) S.slot.value = state.slot;
    S.add.disabled = adding || !cur;
    S.add.textContent = adding && addingFrom === 'sheet' ? '追加しています' : 'カートに入れる';
    /* 入れた後は「ご注文へ進む」が主ボタン。「カートに入れる」は枠だけに下げる */
    S.add.classList.toggle('nssm-btn--primary', !ordering);
    S.add.classList.toggle('nssm-btn--outline', ordering);
  }

  /* 開いている間は、背面(body直下のサイトのヘッダー・本文・フッター・ドックなど)を操作できなくする。
     inertが使える環境はinert、使えない古い環境は読み上げから外す(aria-hidden)。どちらでも、Tabの移動は
     onKeyで、それ以外の手段でフォーカスが外へ出た時はonFocusInで、シートの中へ戻す。
     元から付いていた属性は触らず、ここで付けたものだけを閉じる時に外す。 */
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
  var NO_MUTE = { SCRIPT: 1, STYLE: 1, LINK: 1, META: 1, NOSCRIPT: 1, TEMPLATE: 1 };
  var HAS_INERT = !!(window.HTMLElement && 'inert' in window.HTMLElement.prototype);
  var muted = [];

  function muteBackground() {
    if (muted.length || !ov || !document.body) return;
    Array.prototype.slice.call(document.body.children).forEach(function (el) {
      if (el === ov || NO_MUTE[el.tagName]) return;
      if (HAS_INERT && 'inert' in el) {
        if (el.inert) return;
        el.inert = true;
        muted.push({ el: el, inert: true });
      } else {
        if (el.getAttribute('aria-hidden') === 'true') return;
        el.setAttribute('aria-hidden', 'true');
        muted.push({ el: el, inert: false });
      }
    });
  }
  function unmuteBackground() {
    muted.forEach(function (m) {
      if (m.inert) m.el.inert = false;
      else m.el.removeAttribute('aria-hidden');
    });
    muted = [];
  }
  /* シートの中でTabが止まる所。同じ組のラジオは選ばれている1つだけ、閉じた欄やhiddenの中は数えない */
  function sheetFocusables() {
    return $$(FOCUSABLE, sheet).filter(function (el) {
      if (el.type === 'radio' && !el.checked) return false;
      return !el.getClientRects || el.getClientRects().length > 0;
    });
  }
  function focusTo(el) {
    if (!el || !el.focus) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }
  function precedes(a, b) { return !!(a.compareDocumentPosition(b) & 4); } /* aがbより前にある */

  function onKey(e) {
    if (e.key === 'Escape' || e.key === 'Esc') { closeSheet(); return; }
    if (e.key !== 'Tab' || !sheetActive) return;
    var list = sheetFocusables();
    if (!list.length) { e.preventDefault(); focusTo(sheet); return; }
    var first = list[0], last = list[list.length - 1];
    var cur = document.activeElement;
    var inside = !!cur && cur !== sheet && sheet.contains(cur);
    /* 最後の次は最初へ、最初の前は最後へ。シート自体やシートの外にいる時も中へ入れる */
    if (e.shiftKey) {
      if (!inside || !precedes(first, cur)) { e.preventDefault(); focusTo(last); }
    } else if (!inside || !precedes(cur, last)) {
      e.preventDefault();
      focusTo(first);
    }
  }
  function onFocusIn(e) {
    if (!sheetActive || !e.target || ov.contains(e.target)) return;
    focusTo(sheet);
  }

  function openSheet(k, opener) {
    if (closed || !VARS.length) return false;
    if (!sheet) buildSheet();
    if (k && TABS[k] && tabOk(k)) setTab(k);
    if (fb.from !== 'sheet') resetFeedback();
    if (!sheetActive) lastFocus = opener || document.activeElement;
    if (S.info) S.info.open = false;
    /* 閉じる動きの途中で開き直した時に、遅れてシートを隠さない */
    window.clearTimeout(closeTimer);
    render();
    ov.hidden = false;
    html.classList.add('nssm-sheet-open');
    if (S.scroll) S.scroll.scrollTop = 0;
    if (!sheetActive) {
      sheetActive = true;
      muteBackground();
      document.addEventListener('keydown', onKey, true);
      document.addEventListener('focusin', onFocusIn, true);
    }
    updateDock();
    window.requestAnimationFrame(function () {
      ov.classList.add('is-open');
      focusTo(sheet);
    });
    return true;
  }

  function closeSheet() {
    if (!ov || ov.hidden || !sheetActive) return;
    sheetActive = false;
    ov.classList.remove('is-open');
    html.classList.remove('nssm-sheet-open');
    document.removeEventListener('keydown', onKey, true);
    document.removeEventListener('focusin', onFocusIn, true);
    /* 背面を戻してから、開いたボタンへフォーカスを戻す(inertのままだと戻せない) */
    unmuteBackground();
    if (fb.from === 'sheet') resetFeedback();
    closeTimer = window.setTimeout(function () {
      if (sheetActive) return;
      ov.hidden = true;
      render();
      updateDock();
    }, 260);
    focusTo(lastFocus);
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var a = e.target.closest('[data-nssm-open]');
    if (!a || !root.contains(a)) return;
    if (closed) return;
    e.preventDefault();
    openSheet(a.getAttribute('data-nssm-open') || '', a);
  });

  /* ---------- 追従ドック ---------- */
  var dock = null, D = {};

  function buildDock() {
    if (dock || !VARS.length) return;
    dock = document.createElement('div');
    dock.className = 'nssm-dock';
    /* 大きさと量は、ドックの選択欄(端末の選択画面)で選ぶ。規格の元は購入ボックスのHTML(VARS)。
       箱数はシートで変える(ドックは狭く、+と「カートに入れる」の押し間違いが起きるため置かない) */
    var groups = TAB_KEYS.map(function (k) {
      return '<optgroup label="' + esc(TABS[k].name) + '" data-dock-group="' + esc(k) + '">' +
        varsOf(k).map(function (v) {
          return '<option value="' + esc(v.id) + '" data-dock-opt="' + esc(v.id) + '"></option>';
        }).join('') + '</optgroup>';
    }).join('');
    dock.innerHTML =
      '<div class="nssm-dock__panel">' +
        '<div class="nssm-dock__info" data-dock-choose>' +
          '<span class="nssm-dock__row"><span class="nssm-dock__chip">送料込み</span>' +
            '<span class="nssm-dock__note">受付は10月20日(火)まで</span></span>' +
          '<label class="nssm-dock__pick">' +
            '<span class="nssm-dock__val" aria-hidden="true"><span data-dock-name></span><b data-dock-price></b></span>' +
            ICON_CHEV +
            '<select data-dock-select aria-label="大きさと量を選ぶ">' + groups + '</select>' +
          '</label>' +
        '</div>' +
        '<div class="nssm-dock__info" data-dock-incart hidden>' +
          '<span class="nssm-dock__row"><span class="nssm-dock__chip" data-dock-count></span>' +
            '<span class="nssm-dock__sum" data-dock-sum></span></span>' +
          '<button type="button" class="nssm-dock__more" data-dock-more>ほかの大きさや量も選ぶ</button>' +
        '</div>' +
        '<button type="button" class="nssm-dock__btn" data-dock-btn>カートに入れる</button>' +
      '</div>';
    document.body.appendChild(dock);
    D = {
      choose: $('[data-dock-choose]', dock),
      incart: $('[data-dock-incart]', dock),
      name: $('[data-dock-name]', dock),
      price: $('[data-dock-price]', dock),
      select: $('[data-dock-select]', dock),
      count: $('[data-dock-count]', dock),
      sum: $('[data-dock-sum]', dock),
      more: $('[data-dock-more]', dock),
      btn: $('[data-dock-btn]', dock)
    };
    /* 選んだ規格は、購入ボックスとシートと同じ状態(setVar)に入れる */
    D.select.addEventListener('change', function () { setVar(D.select.value); });
    /* カートに1点以上: ほかの規格は、箱数と時間帯も選べるシートで追加する(カートの中身を変える操作と誤解させない) */
    D.more.addEventListener('click', function () { openSheet('', D.more); });
    D.btn.addEventListener('click', function () {
      /* カートに1点以上: 時間帯の欄と「ご注文へ進む」があるシートを開く */
      if (cartCount > 0) {
        fb = { from: 'sheet', msg: 'ご注文の前に、時間帯を選べます。', error: false };
        openSheet('', D.btn);
        return;
      }
      addToCart('dock');
    });
  }

  function renderDock() {
    if (!dock) return;
    var cur = findVar(state.vid);
    var inCart = cartCount > 0;
    dock.classList.toggle('is-cart', inCart);
    D.choose.hidden = inCart;
    D.incart.hidden = !inCart;
    if (inCart) {
      D.count.textContent = 'カートに' + cartCount + '点';
      D.sum.innerHTML = (fb.from === 'dock' && !fb.error ? '追加しました・' : '') + '合計<b>' + esc(yen(cartTotal)) + '</b>';
      D.btn.textContent = 'ご注文へ進む';
      D.btn.disabled = false;
      return;
    }
    TAB_KEYS.forEach(function (k) {
      var g = $('[data-dock-group="' + k + '"]', D.select);
      if (g) g.disabled = !tabOk(k);
    });
    VARS.forEach(function (v) {
      var o = $('[data-dock-opt="' + v.id + '"]', D.select);
      if (!o) return;
      o.textContent = TABS[v.tab].name + v.n + '(' + (v.ok ? yen(v.price) : '完売') + ')';
      o.disabled = !v.ok;
    });
    if (cur && D.select.value !== cur.id) D.select.value = cur.id;
    D.select.disabled = adding;
    D.name.textContent = cur ? cur.short + (state.qty > 1 ? '×' + state.qty + '箱' : '') : '';
    D.price.textContent = cur ? yen(cur.price * state.qty) : '';
    D.btn.textContent = adding && addingFrom === 'dock' ? '追加しています' : 'カートに入れる';
    D.btn.disabled = adding || !cur;
  }

  function inView(el, pad) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight - pad && r.bottom > pad;
  }
  function updateDock() {
    if (!dock) return;
    var fvEl = $('#fv', root);
    var pastFv = fvEl ? fvEl.getBoundingClientRect().bottom < 40 : true;
    var buyCard = $('.nssm-buy__card', root);
    var last = $('#cta', root);
    var sheetOpen = !!(ov && !ov.hidden);
    var show = !closed && pastFv && !inView(buyCard, 80) && !inView(last, 60) && !sheetOpen;
    dock.classList.toggle('is-shown', show);
    document.body.classList.toggle('nssm-dock-active', show);
  }

  /* ---------- 受付終了 ---------- */
  function closeAll() {
    if (closed) return;
    closed = true;
    root.classList.add('is-closed');
    if (ov && !ov.hidden) closeSheet();
    updateDock();
  }

  function updatePriceRows() {
    TAB_KEYS.forEach(function (k) {
      var ok = tabOk(k);
      var min = varsOf(k).filter(function (v) { return v.ok; })[0];
      $$('[data-nssm-price-tab="' + k + '"]', root).forEach(function (row) {
        row.hidden = !ok;
        if (!min) return;
        var n = $('.nssm-price-row__n span:last-child', row);
        var b = $('b', row);
        if (n) n.textContent = min.n;
        if (b) b.textContent = yen(min.price);
      });
      $$('[data-nssm-open="' + k + '"]', root).forEach(function (a) { a.hidden = !ok; });
    });
    VARS.forEach(function (v) {
      if (v.ok) return;
      $$('[data-nssm-vid="' + v.id + '"] b', root).forEach(function (b) { b.textContent = '完売'; });
    });
  }

  /* 読み込み時に販売状態を取り直す(ページのキャッシュで古い表示が残っても、売り切れを反映する) */
  function recheckAvailability() {
    if (closed || !window.fetch || !window.Promise) return Promise.resolve();
    return Promise.all(TAB_KEYS.map(function (k) {
      var h = TABS[k].handle;
      if (!h) return Promise.resolve(null);
      return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (list) {
      var changed = false;
      list.forEach(function (p, i) {
        if (!p || !p.variants) return;
        var avail = {};
        p.variants.forEach(function (v) { avail[String(v.id)] = !!v.available; });
        varsOf(TAB_KEYS[i]).forEach(function (v) {
          if (Object.prototype.hasOwnProperty.call(avail, v.id) && !avail[v.id] && v.ok) {
            v.ok = false;
            changed = true;
          }
        });
      });
      if (!changed) return;
      if (!TAB_KEYS.some(tabOk)) { closeAll(); return; }
      var cur = findVar(state.vid);
      if (!cur || !cur.ok) {
        var k = tabOk(state.tab) ? state.tab : TAB_KEYS.filter(tabOk)[0];
        var d = pickDefault(k);
        state.tab = k;
        state.vid = d ? d.id : null;
      }
      updatePriceRows();
      render();
    });
  }

  var deadline = Date.parse(root.getAttribute('data-deadline') || '');
  if (!isNaN(deadline)) {
    var left = deadline - Date.now();
    if (left <= 0) closeAll();
    else if (left < 2147483000) window.setTimeout(closeAll, left + 1000);
  }

  /* ---------- 召し上がった方の声(SPの横スライドで、いま何件目かを出す) ---------- */
  (function voiceCount() {
    var list = $('.nssm-voice__list', root);
    var out = $('[data-nssm-voice-count]', root);
    if (!list || !out) return;
    var items = $$('.nssm-voice__item', list);
    var ticking = false;
    function update() {
      ticking = false;
      if (list.scrollWidth <= list.clientWidth + 2) { out.hidden = true; return; }
      var pad = parseFloat(window.getComputedStyle(list).paddingLeft) || 0;
      var idx = 0, best = Infinity;
      items.forEach(function (it, i) {
        var d = Math.abs(it.offsetLeft - pad - list.scrollLeft);
        if (d < best) { best = d; idx = i; }
      });
      out.textContent = (idx + 1) + '/' + items.length;
      out.hidden = false;
    }
    function queue() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
    list.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    update();
  })();

  /* ---------- 起動 ---------- */
  if (VARS.length) {
    buildDock();
    render();
    refreshCart();
    updateDock();
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { updateDock(); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', updateDock, { passive: true });
    recheckAvailability();
  }
})();
